export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-primary-500/10 to-accent-500/10 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20concept%20with%20warm%20ambient%20lighting%2C%20clean%20minimalist%20home%20entertainment%20setup%2C%20large%20display%20screen%20with%20soft%20glow%2C%20cozy%20living%20room%20atmosphere%2C%20cinematic%20aesthetic%2C%20no%20text&width=1000&height=700&seq=about-platform-2026&orientation=landscape"
                alt="大师兄影视平台介绍"
                className="relative w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">平台介绍</h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                大师兄影视成立于2020年，是国内领先的免费高清在线观影平台。我们致力于为每一位影视爱好者提供最优质的观影服务，让好内容被更多人看到。
              </p>
              <p>
                平台汇聚超过<strong className="text-foreground-900">10万部</strong>影视资源，涵盖国产剧、海外剧、院线电影、动漫番剧、综艺娱乐等全品类内容。我们与多家内容方达成合作，确保片源正版、更新及时。
              </p>
              <p>
                技术团队持续优化播放体验，采用先进的<strong className="text-foreground-900">P2P-CDN混合加速技术</strong>，在全国部署超过200个加速节点，确保无论您身在何处都能享受秒开流畅的观影体验。
              </p>
              <p>
                大师兄影视坚持<strong className="text-foreground-900">用户至上</strong>的理念，全程无广告打扰，不做任何付费墙。我们相信，好的观影体验不应该被商业化的干扰所破坏。未来，我们将继续优化服务，拓展更多优质内容，成为您最信赖的观影伙伴。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-primary-600"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">运营5年+</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-team-line text-accent-600"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">500万+用户信赖</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-award-line text-primary-600"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">行业口碑品牌</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}